<template>
  <v-card flat class="rounded-xl overflow-hidden pa-8"> 
            <vue-table
              :data="tableData"
              :headers="headers"
              :loading="syncLoading || loading"
              @change="onPagination"
              :item-class="getRowClass"
            >
              <!-- یکپارچه‌سازی فیلترها درون اسلات جدول -->
              <template v-slot:filters="{ props, perPage }">
                <v-row no-gutters class="mb-4">
                  <v-col class="pa-2" cols="12" lg="2" md="3">
                    <v-select
                      v-model="props.length"
                      :items="perPage"
                      class="rounded-lg"
                      dense
                      hide-details
                      :label="$t('qrUsersList.perPage')"
                      outlined
                      @change="() => onPagination(props)"
                    />
                  </v-col>      
                  <v-col class="pa-2" cols="12" lg="2" md="3">
                    <v-select
                      v-model="props.column"
                      :items="columnOptions"
                      label="مرتب‌سازی براساس"
                      dense
                      hide-details
                      outlined
                      class="rounded-lg"
                      @change="() => onPagination(props)"
                    />
                  </v-col>
                  <v-col class="pa-2" cols="12" lg="2" md="3">
                    <v-select
                      v-model="props.dir"
                      :items="dirOptions"
                      label="جهت مرتب‌سازی"
                      dense
                      hide-details
                      outlined
                      class="rounded-lg"
                      @change="() => onPagination(props)"
                    />
                  </v-col>
                  <v-col class="pa-2" cols="12" lg="3" md="3">
                    <v-text-field
                      v-model="props.search"
                      append-icon="mdi-magnify"
                      label="جستجو در عنوان..."
                      outlined
                      dense
                      hide-details
                      clearable
                      class="rounded-lg"
                      @keyup.enter="() => onPagination(props)"
                      @click:clear="() => { props.search = null; onPagination(props); }"
                    />
                  </v-col>
                  <v-col class="pa-2" cols="12" lg="3" md="3">
                    <v-select
                      v-model="props.flag"
                      :items="flagOptions"
                      label="فیلتر وضعیت"
                      outlined
                      prepend-inner-icon="mdi-filter-variant"
                      dense
                      hide-details
                      clearable
                      class="rounded-lg"
                      @change="() => onPagination(props)"
                    />
                  </v-col>
                </v-row>
              </template>

              <template v-slot:index="{item}">
                {{ persian(item.index + 1 + (tableData.current_page - 1) * tableData.per_page) }}
              </template>


              <template v-slot:image_src="{ item }">
                <div class="d-flex flex-column align-center pa-2">
                  <v-img :src="item.image_src" max-width="115" max-height="115" contain />
                </div>
              </template>
              <template v-slot:reference_price_issue="{ item }">
                <div class="d-flex flex-column align-center pa-2">
                  {{item.reference_price_issue? 'مشکل قیمت مرجع':''}}
                </div>
              </template>

              <template v-slot:kala="{ item }">
                <div class="d-flex flex-column align-start text-right py-2">
                  <div class="product-title font-weight-bold mb-1">
                    <template v-if="item.title && item.title.includes(':')">
                      <div>{{ item.title.split(':')[0] }} :</div>
                      <div class="primary--text mt-1">{{ item.title.split(':').slice(1).join(':') }}</div>
                    </template>
                    <template v-else>
                      {{ item.title }}
                    </template>
                  </div>                 
                  <div class="d-flex align-center gap-2 grey--text text--darken-1 text-caption">
                    <a :href="`https://www.digikala.com/product/dkp-${item.product_id}`" target="_blank" class="dkp-link">
                      DKP-{{ item.product_id }}
                    </a>
                    <span class="mx-1">|</span>
                    <span>{{ item.product_id }}</span>

                    <span class="mx-1">|</span>
                    <span class="variant-code">DKPC-{{ item.variant_id }}</span>
                  </div>
                </div>
              </template>
                    <template v-slot:variant_id="{item}">
        <v-chip class="px-2 py-3 rounded-lg" color="transparent">
          <span class="text-body-2 font-weight-bold">
            {{ persian(item.variant_id) }}
          </span>
          <v-btn icon small @click.stop="copyID(item.variant_id)" class="ms-2" color="#B5C5FD">
            <v-icon small>mdi-content-copy</v-icon>
          </v-btn>
        </v-chip>
      </template>


              <template v-slot:updated_at="{ item }">
                <v-icon small class="ml-1">mdi-clock-outline</v-icon>
                {{ jalalian(item.updated_at,"datetime") }}
              </template>

              <template v-slot:flag="{ item }">
                <v-chip :color="getFlagColor(item.flag)" text-color="white" small class="pa-2">
                  {{ getFlagText(item.flag) }}
                </v-chip>
              </template>
                    <template v-slot:action="{ item }">
                      <action-buttons :data="item" :meta="metabutton" />
                  </template>

            </vue-table>
      <custom-popup
      v-model="showDialog"
      :cons="{ title: 'افزودن/ویرایش قیمت هوشمند' }"
      max-width="600"
      :reloadable="false"
      :persistent="true"
      @close="resetForm"
    >
      <v-card class="pa-4" flat>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <!-- <v-col cols="12" md="6">
              <v-text-field
                v-model.number="formData.product_id"
                label="شناسه محصول (Product ID)"
                type="number"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="formData.variant_id"
                label="شناسه تنوع (Variant ID)"
                type="number"
                outlined
                dense
              ></v-text-field>
            </v-col> -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="formData.min_price"
                label="حداقل قیمت"
                type="number"
                :rules="[(v) => !!v || 'وارد کردن حداقل قیمت الزامی است',
                (v) => v >= 0 || 'قیمت نمی‌تواند منفی باشد']"
                outlined
                dense
                :min="0"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="formData.max_price"
                label="حداکثر قیمت"
                :rules="[(v) => !!v || 'وارد کردن حداکثر قیمت الزامی است',
                (v) => v >= 0 || 'قیمت نمی‌تواند منفی باشد',
                (v) => Number(v) > Number(formData.min_price) || 'حداکثر قیمت باید حتماً بزرگتر از حداقل قیمت باشد',]"

                type="number"
                outlined
                dense
                :min="formData.min_price"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="formData.price_step"
                label="کسر قیمت"
                type="number"
                :rules="[(v) => !!v || 'وارد کردن  کسر قیمت الزامی است',        
                (v) => v >= 2000 || 'کسر قیمت نمی‌تواند کمتر از 2000 باشد']"
                outlined
                dense
                min="2000"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-switch
                v-model="formData.is_enabled"
                label="وضعیت فعالیت"
                color="primary"
              ></v-switch>
            </v-col>
          <v-col cols="12" md="6">
          <v-switch
            v-model="formData.has_discount"
            :true-value="1"
            :false-value="0"
            label="تخفیف دارد"
            color="primary"
          ></v-switch>
            </v-col>

          </v-row>
          <div class="d-flex flex-row justify-space-between mt-4">
            <v-btn
              :loading="saving"
              class="btn-get-code rounded-lg px-6"
              @click="saveData"
              :disabled="!valid || !validComputed" 
            >
              <v-icon left>mdi-check</v-icon>
              ثبت
            </v-btn>  
            <v-btn
              :loading="saving"
              class="btn-delete rounded-lg px-6"
              @click="showDialog = false"
            >
              <v-icon left>mdi-close</v-icon>
              لغو
            </v-btn>        
          </div>
        </v-form>
      </v-card>
    </custom-popup>
  </v-card>
</template>

<script>
import Timepicker from "@/view/components/Timepicker";
import RepricerReportTab from "./RepricerReportTab.vue";
import SmartPricesTab from "./SmartPricesTab.vue";
import ActionButtons from "@/view/components/adapters/qrList/ordersListButton.vue";
import SettingRunTime from "./SettingRunTime.vue";

export default {
  name: "ShowSetPrice_deactive",
  components: { SettingRunTime, Timepicker, SmartPricesTab, RepricerReportTab,ActionButtons },
  data: () => ({
      SmartRow:{},
      loading: false,
      saving: false,
      showDialog: false,
      isEditing: false,
      valid: false,
      smartPrices: [],
       formData: {
        id: null,
        variant_id: null,
        product_id: null,
        min_price: null,
        max_price: null,
        price_step: null,
        is_enabled: true,
        has_discount: 0,
      },
      defaultForm: {
        id: null,
        variant_id: null,
        product_id: null,
        min_price: 0,
        max_price: 0,
        price_step: 20000,
        is_enabled: true,
      has_discount: 0,

      },
    tabs: 0,
    tabItems: [
      { text: "لیست تنوع‌ها", value: 0, icon: 'format-list-bulleted' },
      { text: "تنظیمات قیمت‌گذاری", value: 1, icon: 'tune' },
      { text: "قیمت گذاری هوشمند", value: 2, icon: "robot-outline" },
      { text: "گزارش جاب", value: 3, icon: "clipboard-text-outline" }
    ],
    
    tableProps: {
      page: 1,
      length: 30,
      search: null,
      flag: null,
      dir: 'desc',
      column: 'updated_at',
      status:0,
    },

    flagOptions: [
      { text: 'همه موارد', value: null },
      { text: 'سبز (بدون رقیب/سقف)', value: 'green' },
      { text: 'زرد (رقیب بالاتر/سقف)', value: 'yellow' },
      { text: 'قرمز (رقابت در بازه مجاز)', value: 'red' },
      { text: 'نارنجی (رقیب ارزان‌تر از کف)', value: 'orange' }
    ],

    columnOptions: [
      { text: "تاریخ بروزرسانی", value: "updated_at" },
      { text: "شناسه تنوع", value: "variant_id" }
    ],
    dirOptions: [
      { text: "نزولی", value: "desc" },
      { text: "صعودی", value: "asc" }
    ],

    tableData: {
      data: [],
      total: 0,
      current_page: 1,
      per_page: 30
    },
    
    loading: false,
    syncLoading: false,
    repriceLoading: false,
    scheduleLoading: false,
    headers: [
      { value: 'index', text: 'ردیف', sortable: false, align: 'center' },
      { value: 'variant_id', text: 'شناسه تنوع', sortable: false, align: 'center' },
      { value: 'image_src', text: 'تصویر محصول', sortable: false, align: 'center' },
      { value: 'kala', text: 'عنوان و کد محصول', sortable: false, align: 'center' },
      // { value: 'flag', text: 'وضعیت', sortable: false, align: 'center' },
      { value: 'updated_at', text: 'آخرین به‌روزرسانی', sortable: false, align: 'center' },
      // { value: "action", text: "عملیات", align: "center", sortable: false, event: "actions" },

    ],
  }),
  mounted() {
    this.fetch();
  },
  computed:{
    validComputed(){
      return !!this.formData.max_price && !!this.formData.min_price;
    },
    metabutton() {
      return {
        buttons: [
          {
            name: "edit",
            label: "قیمت‌گذاری هوشمند",
            icon: "cash-sync",
            class: "btn-download rounded-pill",
            action: this.actions,
          },
        ],
      };
    },

  },
  methods: {
        openAddDialog() {
      this.isEditing = false;
      this.formData = { ...this.defaultForm };
      this.showDialog = true;
    }, 
        resetForm() {
      this.formData = { ...this.defaultForm };
      this.isEditing = false;
      if (this.$refs.form) this.$refs.form.resetValidation();
    },

    saveData() {
      this.saving = true;
      const method = this.isEditing ? "put" : "post";
      const url = this.isEditing
        ? `/v1/digikala/multi-pricing/${this.formData.id}`
        : "/v1/digikala/multi-pricing/store";

      this.$api[method](url, this.formData)
        .then(() => {
          this.$toast.success(this.isEditing ? "با موفقیت ویرایش شد" : "با موفقیت ذخیره شد");
          this.showDialog = false;
          this.fetch();
          this.tabs=2;
        })
        .catch(() => {
          this.$toast.error("خطا در ذخیره اطلاعات");
        })
        .finally(() => {
          this.saving = false;
        });
    },

    actions(data, type) {
      if (type === "edit") {
        this.editAction(data);
      } 
    },

   async editAction(data) {
    console.log(data,"DATA")
      this.getSmartRow(data);
      this.showDialog = true;
    },

        copyID(textToCopy) {
      const text = String(textToCopy); 
      
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.$toast.success("با موفقیت کپی شد");
          })
          .catch((err) => {
            console.error("Clipboard error:", err);
            this.$toast.error("خطا در کپی");
          });
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.$toast.success("با موفقیت کپی شد");
      }
    },

    getRowClass(item) {
      let rowClasses = [];

      if (item.reference_price_issue == 1) {
        rowClasses.push('reference-issue-row');
      }

      if (item.flag) {
        const flagClasses = {
          green: 'row-bg-green',
          yellow: 'row-bg-yellow',
          red: 'row-bg-red',
          orange: 'row-bg-orange'
        };
        if (flagClasses[item.flag]) {
          rowClasses.push(flagClasses[item.flag]);
        }
      }
      
      return rowClasses.join(' ');
    },
    async getSmartRow(data){
      try {
        const res = await this.$api.get(`v1/digikala/multi-pricing/find/${data.id}`);
        this.SmartRow = res?.data?.data; 
        if(this.SmartRow===null || this.SmartRow === undefined)
      {
        this.isEditing = false;
        this.formData={...this.formData,
          variant_id:data.variant_id,
          product_id:data.product_id
        }
        
      }else{
        this.isEditing = true;
        this.formData = this.SmartRow;
      }
      } catch (error) {
        this.$toast.error("خطا در دریافت قیمت گذاری هوشمند");
      } finally {
      }

    },
    async fetch() {
      this.loading = true;
      try {
        const res = await this.$api.get('/v1/digikala/variant-list', { params: this.tableProps });
        this.tableData = res.data.data || res.data; 
      } catch (error) {
        this.$toast.error("خطا در دریافت لیست تنوع‌ها");
      } finally {
        this.loading = false;
      }
    },

    onPagination(e) {
      if (e && typeof e === 'object' && !Array.isArray(e)) {
        if (
          ('search' in e && e.search !== this.tableProps.search) || 
          ('flag' in e && e.flag !== this.tableProps.flag)
        ) {
          e.page = 1;
        }
        this.tableProps = { ...this.tableProps, ...e };
      }
      this.fetch();
    },

    async syncVariants() {
      this.syncLoading = true;
      try {
        await this.$api.post('/v1/digikala/sync-variants');
        this.$toast.success("درخواست همگام‌سازی با موفقیت در صف قرار گرفت");
        this.fetch();
      } catch (error) {
        this.$toast.error("خطا در همگام‌سازی تنوع‌ها");
      } finally {
        this.syncLoading = false;
      }
    },

    async triggerRepricing() {
      this.repriceLoading = true;
      try {
        await this.$api.post('/v1/digikala/repricing');
        this.$toast.success("درخواست بررسی قیمت‌ها در صف قرار گرفت");
      } catch (error) {
        this.$toast.error("خطا در اجرای عملیات قیمت‌گذاری");
      } finally {
        this.repriceLoading = false;
      }
    },
    getFlagText(flag) {
      const map = {
        green: "رقیب ندارد (قیمت سقف)",
        yellow: "قیمت رقیب بالا (قیمت سقف)",
        red: "کسری قیمت (رقابت)",
        orange: "رقیب ارزان‌تر از کف (قیمت کف)"
      };
      return map[flag] || flag || "بررسی نشده";
    },

    getFlagColor(flag) {
      const map = {
        green: "success",
        yellow: "warning",
        red: "error",
        orange: "orange"
      };
      return map[flag] || "grey";
    }
  }
};
</script>

<style scoped>
.gap-4 {
  gap: 16px;
}

::v-deep .row-bg-green {
  background-color: #e8f5e9 !important;
}

::v-deep .row-bg-yellow {
  background-color: #fffde7 !important;
}

::v-deep .row-bg-red {
  background-color: #ffebee !important; 
}

::v-deep .row-bg-orange {
  background-color: #fff3e0 !important; 
}

::v-deep .row-bg-green:hover { background-color: #c8e6c9 !important; }
::v-deep .row-bg-yellow:hover { background-color: #fff9c4 !important; }
::v-deep .row-bg-red:hover { background-color: #ffcdd2 !important; }
::v-deep .row-bg-orange:hover { background-color: #ffe0b2 !important; }
.gap-2 { gap: 8px; }
.gap-4 { gap: 16px; }

.product-title {
  font-size: 0.9rem;
  color: #424242;
  line-height: 1.6;
}

.dkp-link {
  text-decoration: none;
  color: #1976d2;
  font-weight: 500;
  border-bottom: 1px dashed #1976d2;
}

.variant-code {
  background: #f0f0f0;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: monospace;
}
::v-deep .reference-issue-row {
  background-color: #ffebee !important;
}

::v-deep .reference-issue-row td:first-child {
  position: relative;
  padding-right: 30px !important; 
}

::v-deep .reference-issue-row td:first-child::before {
  content: 'مشکل قیمت مرجع'; 

  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #ff5252;
  color: white;
  font-size: 11px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  padding: 0 4px;
  z-index: 1;
  box-shadow: -2px 0 4px rgba(0,0,0,0.1); 
}

</style>
